import { Component, OnInit, Input } from '@angular/core';

import { DebtorManagement } from '../../../shared/models/debtorManagement.model';

@Component({
  selector: 'app-summary-portfolio',
  templateUrl: './summary-portfolio.component.html',
  styleUrls: ['./summary-portfolio.component.css']
})
export class SummaryPortfolioComponent implements OnInit {

  @Input() portfolio: DebtorManagement;
  constructor() { }

  ngOnInit() {
  }
}
